module.exports = __webpack_public_path__ + "643ee8b3ad7bc78f3ac3964e59f63307.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/nail_salon2.jpg
// module id = 584
// module chunks = 16